// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7c5897bd","553":"4ffd1e2b","977":"386d2849"}[chunkId] + ".chunk.js";
};